import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import './Home.css';

export default class Contact extends React.Component {
    render() {
        return (
            <div className="holder">
                <div style={{ marginBottom: "1.75rem" }}>
                    <h2 style={{ marginBottom: "0.25rem" }}>Contact Us</h2>
                    <p className="text-muted" style={{ marginBottom: 0 }}>
                        Parkway Driving School — reach us by phone, text, or email.
                    </p>
                </div>

                {/* Contact methods */}
                <Row style={{ marginBottom: "1.5rem" }}>
                    <Col md={4} style={{ marginBottom: "1rem" }}>
                        <Card className="h-100 text-center">
                            <Card.Body style={{ padding: "1.5rem" }}>
                                <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}><span role="img" aria-label="Telephone">📞</span></div>
                                <Card.Title style={{ fontSize: "1rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Telephone
                                </Card.Title>
                                <a href="tel:617-477-4257" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
                                    617-477-4257
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} style={{ marginBottom: "1rem" }}>
                        <Card className="h-100 text-center">
                            <Card.Body style={{ padding: "1.5rem" }}>
                                <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}><span role="img" aria-label="Text message">💬</span></div>
                                <Card.Title style={{ fontSize: "1rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Text Line Only
                                </Card.Title>
                                <a href="sms:617-564-3803" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
                                    617-564-3803
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} style={{ marginBottom: "1rem" }}>
                        <Card className="h-100 text-center">
                            <Card.Body style={{ padding: "1.5rem" }}>
                                <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}><span role="img" aria-label="Email">✉️</span></div>
                                <Card.Title style={{ fontSize: "1rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Email
                                </Card.Title>
                                <a href="mailto:info@parkwaydrivingschool.com" style={{ fontSize: "1rem", fontWeight: 500, wordBreak: "break-all" }}>
                                    info@parkwaydrivingschool.com
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Hours */}
                <Row>
                    <Col md={6} style={{ marginBottom: "1rem" }}>
                        <Card className="h-100">
                            <Card.Body style={{ padding: "1.5rem" }}>
                                <Card.Title style={{ fontSize: "1rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "1rem" }}>
                                    Office Hours
                                </Card.Title>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingBottom: "0.25rem", color: "#495057" }}>Mon – Thu</td>
                                            <td style={{ paddingBottom: "0.25rem", fontWeight: 500, textAlign: "right" }}>10:00 AM – 4:00 PM</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} style={{ marginBottom: "1rem" }}>
                        <Card className="h-100">
                            <Card.Body style={{ padding: "1.5rem" }}>
                                <Card.Title style={{ fontSize: "1rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "1rem" }}>
                                    Driving Hours
                                </Card.Title>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingBottom: "0.25rem", color: "#495057" }}>Mon – Fri</td>
                                            <td style={{ paddingBottom: "0.25rem", fontWeight: 500, textAlign: "right" }}>9:00 AM – 8:00 PM</td>
                                        </tr>
                                        <tr>
                                            <td style={{ color: "#495057" }}>Sat – Sun</td>
                                            <td style={{ fontWeight: 500, textAlign: "right" }}>9:00 AM – 4:00 PM</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
